import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { AppConfigService } from './auth-guard/appconfig.service';
import { AuthInterceptor } from './auth-guard/auth-interceptor';
import { ErrorInterceptor } from './auth-guard/error.interceptor';
import * as auth from './auth-guard/auth.factories';
import { AuthGuard } from './auth-guard/auth.guard';

const isBrowser = typeof globalThis !== 'undefined'
  && globalThis.window !== undefined
  && globalThis.document !== undefined;

// Base providers (always included)
// Note: AppConfigService loads config.json synchronously in its constructor,
// so it's available immediately when other services need it.
const baseProviders = [
  provideRouter(routes),
  provideHttpClient(withInterceptorsFromDi()),
  provideBrowserGlobalErrorListeners(),
  provideZoneChangeDetection({ eventCoalescing: true }),
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];

const authFactories = new auth.AuthFactories();
const msalProviders = environment.msalEnable && isBrowser ? [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: authFactories.MSALInstanceFactory,
    deps: [AppConfigService]
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: authFactories.MSALGuardConfigFactory,
    deps: [AppConfigService]
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: authFactories.MSALInterceptorConfigFactory,
    deps: [AppConfigService]
  },
  {
    provide: APP_INITIALIZER,
    useFactory: authFactories.MSALInstanceSetActiveAccountFactory,
    deps: [AppConfigService, MSAL_INSTANCE],
    multi: true
  },
  MsalService,
  AuthGuard,
  MsalBroadcastService
] : [];

export const appConfig: ApplicationConfig = {
  providers: [
    ...baseProviders,
    ...msalProviders
  ],
};